export const helpData = {
  Project: [
    { id: 'add_project', label: 'How to add a Project?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' },
    { id: 'view_project', label: 'How to select & view a Project?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' },
    { id: 'rename_project', label: 'How to rename a Project?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' },
    { id: 'delete_projects', label: 'How to delete Projects?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' }
  ],
  'Item Definition': [
    { id: 'add_data_node', label: 'How to add a component/Data?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' },
    { id: 'add_edge', label: 'How to add a Connector?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' },
    { id: 'delete_node', label: 'How to delete a component?', gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif' },
    {
      id: 'edit_data_node',
      label: 'How to edit, assign Properties for components/Data?',
      gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif'
    },
    { id: 'edit_edge', label: 'How to edit, assign Properties?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' }
  ],
  'Damage Scenarios and Impact Ratings': {
    'Damage Scenario (Ds) Derivations': [
      { id: 'add_damage_derivation', label: 'How to add a derivation?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' },
      {
        id: 'check_derivation',
        label: 'How to check the checkbox?',
        gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      }
    ],
    'Damage Scenario - Impact Ratings': [
      {
        id: 'add_damage_scene_impact_rating',
        label: 'How to add an impact rating?',
        gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif'
      },
      {
        id: 'damage_scene_edit_name_desc',
        label: 'How to edit name & description?',
        gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif'
      },
      { id: 'delete_damage_scene', label: 'How to delete a scene?', gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif' },
      {
        id: 'add_cyberloss_impacts',
        label: 'How to add cybersecurity losses and assign impact ratings?',
        gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif'
      }
    ]
  },
  'Threat Scenarios': {
    'Threat Scenarios': [
      { id: 'add_threat_scene', label: 'How to add a threat scenario?', gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif' },
      {
        id: 'delete_threat_scene',
        label: 'How to delete a threat scenario?',
        gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      }
    ],
    'Derived Threat Scenarios': [
      { id: 'add_derived_threat', label: 'How to add a derived scene?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' },
      {
        id: 'delete_derived_threat',
        label: 'How to delete a derived scene?',
        gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      }
      //   {
      //     id: 'update_derived_threat',
      //     label: 'How to update the derived scene',
      //     gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      //   }
    ]
  },
  'Attack Path Analysis': {
    Attacks: [
      { id: 'add_attacks', label: 'How to add an attack?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' },
      {
        id: 'delete_attack_attack_trees',
        label: 'How to delete an attack?',
        gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      },
      { id: 'attack-feasability-rating', label: 'How to assign values?', gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif' },
      {
        id: 'use_attacks',
        label: 'How to use attacks in attack trees?',
        gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      }
    ],
    'Attack trees': [
      { id: 'add_attack_tree', label: 'How to add an attack tree?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' },
      {
        id: 'global_attack_tree',
        label: 'How to add a global attack tree?',
        gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif'
      },

      {
        id: 'draw_attack_tree',
        label: 'How to build an attack tree?',
        gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      },
      {
        id: 'use_global_attacks_in_attack_tree',
        label: 'How to use a global attack tree?',
        gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      },
      {
        id: 'convert_attack',
        label: 'How to convert events into attacks/requirements?',
        gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      }
    ]
  },
  'Goals, Claims and Requirements': {
    'Cybersecurity Goals,claims,controls & Requirements': [
      {
        id: 'ADD_CybersecurityGoal',
        label: 'How to add a goal/claim/control/requirement?',
        gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif'
      },
      {
        id: 'export_cybersecurity',
        label: 'How to export cybersecurity?',
        gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
      }
    ]
  },
  'Risk Determination and Risk Treatment Decision': [
    {
      id: 'ADD_Risk_treatment',
      label: 'How to a threat scene to view the risk?',
      gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif'
    },
    {
      id: 'add_goals_to_risk',
      label: 'How to assign cybersecurity Goals/claims?',
      gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
    },
    {
      id: 'ADD_EDIT_Catalogs',
      label: 'How to assign catalogs?',
      gif: 'https://media.giphy.com/media/26tPplGWjN0xLybiU/giphy.gif'
    }
  ],

  Reporting: [
    { id: 'download_report', label: 'How to create a report?', gif: 'https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif' }
  ]
};
